<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{options?.title || 'Change Password'}}</h4>
</div>
<div class="form-group modal-body">
    <p [innerHTML]="$safeNavigationMigration(options?.body)"></p>
    <div class="form-group">
        <label>New password</label>
        <input autofocus class="form-control" type="password" #password1 (keyup)="0" />
    </div>
    <div class="form-group">
        <label>Type new password again</label>
        <input class="form-control" type="password" #password2 (keyup)="0" />
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="!password1.value || (password1.value != password2.value)" (click)="ok(password1.value)">{{options?.okButtonText || 'Ok'}}</button>
    <button type="button" class="btn btn-link" (click)="close()">{{options?.cancelButtonText || 'Cancel'}}</button>
</div>